export default __webpack_public_path__ + "static/media/gallery_02.22d1f717.jpg";